import React from 'react';
import useDevice from '@src/hooks/screen/useDevice';
import classNames from 'classnames';
import Image from 'next/image';

import { iconConfig } from './circleConfig';

import styles from './LandingBenefitsSteps.module.scss';

const LandingBenefitsStepsIcon = () => {
  const { isDesktop } = useDevice();
  const heartAnim = classNames(styles.LandingBenefitsSteps__icons__item, styles.HeartAnim);
  const noteAnim = classNames(styles.LandingBenefitsSteps__icons__item, styles.NoteAnim);
  const carAnim = classNames(styles.LandingBenefitsSteps__icons__item, styles.CarAnim);
  const crossAnim = classNames(styles.LandingBenefitsSteps__icons__item, styles.CrossAnim);

  return (
    <>
      <div className={styles.LandingBenefitsSteps__icons}>
        <div
          className={heartAnim}
          style={isDesktop ? iconConfig.heart.desktop : iconConfig.heart.mobile}
        >
          <Image src="/images/icon/heart.png" width={40} height={40} alt="" />
        </div>
        <div
          className={noteAnim}
          style={isDesktop ? iconConfig.note.desktop : iconConfig.note.mobile}
        >
          <Image src="/images/icon/notas.png" alt="" width={40} height={40} />
        </div>
        <div className={carAnim} style={isDesktop ? iconConfig.car.desktop : iconConfig.car.mobile}>
          <Image src="/images/landing/hero_chip_3.png" width={40} height={40} alt="" />
        </div>
        <div
          className={crossAnim}
          style={isDesktop ? iconConfig.cross.desktop : iconConfig.cross.mobile}
        >
          <Image src="/images/landing/hero_chip_2.png" fill alt="" />
        </div>
      </div>
    </>
  );
};

export default LandingBenefitsStepsIcon;
